/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Pick_LeadInputs */

const en_dr_pick_lead = /** @type {(inputs: Dr_Pick_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Design Room ends as a plan, so it lives next to the plans of one workspace.`)
};

const id_dr_pick_lead = /** @type {(inputs: Dr_Pick_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design Room berakhir sebagai plan, jadi ia tinggal berdampingan dengan plan di satu workspace.`)
};

/**
* | output |
* | --- |
* | "A Design Room ends as a plan, so it lives next to the plans of one workspace." |
*
* @param {Dr_Pick_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_pick_lead = /** @type {((inputs?: Dr_Pick_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Pick_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_pick_lead(inputs)
	return en_dr_pick_lead(inputs)
});